export function composeMouseEventHandler(handler, eventHandler) {
    return (event) => {
        if (eventHandler) {
            eventHandler(event);
        }
        handler(event);
    };
}
export function composeFocusEventHandler(handler, eventHandler) {
    return (event) => {
        if (eventHandler) {
            eventHandler(event);
        }
        handler(event);
    };
}
